/**
 * External links discovered through site puzzles.
 * Confirm / replace LinkedIn URL if this profile is wrong.
 */
export const LINKEDIN_URL = 'https://www.linkedin.com/in/michael-steele-46475523';

export const STEELEDEZIGN_URL = 'https://steeledezign.com/';
